function mudar_format_pagamento(id)
{
	if (confirm('Deseja realmente alterar a forma de pagamento deste pedido?'))
	{
		location = Utils.path + 'pedido/mudar_pagamento/' + id;
		
		return true;
	}

	return false;
}

$('.content-item').each(function () {
    var contador = 0;

    $(this).find('.item').each(function () {
       contador++;
    });

    $(this).find('.q-itens').text(contador+ (contador == 1 ? ' item' :' itens'));

    if(contador < 1) {
        $(this).hide();
    }
});

$('.m-pedido-jumbo .m-content .content-item a i').click(function(event) {
    $(this).closest('.content-item').toggleClass('close-item');
});